import { useEffect, useState } from "react";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { api } from "../lib/api";

/** Pulls public contact info from /api/settings/public. Renders "Contact info
 *  coming soon" when a field is null — NEVER invents placeholder numbers. */
export default function ContactBlock({ compact = false }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let ignore = false;
    api.get("/settings/public")
      .then((r) => !ignore && setSettings(r.data))
      .catch(() => !ignore && setSettings({}));
    return () => {
      ignore = true;
    };
  }, []);

  const phone = settings?.public_phone || null;
  const whatsapp = settings?.public_whatsapp || null;
  const email = settings?.public_email || null;
  const anything = phone || whatsapp || email;

  return (
    <div data-testid="contact-block">
      {!anything && (
        <p
          className="text-sm text-hbe-ink/55"
          data-testid="contact-block-empty"
        >
          Contact info coming soon.
        </p>
      )}
      <div className={`flex flex-wrap gap-3 ${compact ? "" : "mt-2"}`}>
        {phone && (
          <a
            href={`tel:${phone.replace(/[^+\d]/g, "")}`}
            className="hbe-btn-ghost"
            data-testid="contact-phone"
          >
            <Phone size={16} className="mr-2" /> {phone}
          </a>
        )}
        {whatsapp && (
          <a
            href={`https://wa.me/${whatsapp.replace(/[^\d]/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hbe-btn-ghost"
            data-testid="contact-whatsapp"
          >
            <MessageCircle size={16} className="mr-2" /> WhatsApp
          </a>
        )}
        {email && (
          <a
            href={`mailto:${email}`}
            className="hbe-btn-ghost"
            data-testid="contact-email"
          >
            <Mail size={16} className="mr-2" /> {email}
          </a>
        )}
      </div>
    </div>
  );
}
